import { Network, USDC_POLYGON } from '@spritz-finance/sdk'
import {
    AccountProvider,
    SubscriptionFrequency,
    SubscriptionType,
    useCreatePaymentSubscriptionMutation,
} from '../../../../../graphql/generated/graphql'
import { SignatureParams } from './signature'

export const useCreateSubscription = () => {
    const [createSubscriptionMutation, { loading }] = useCreatePaymentSubscriptionMutation()

    const createSubscription = async ({
        accountId,
        provider,
        startDate,
        totalPayments,
        walletAddress,
        amount,
        signedMessage,
        signatureParams,
    }: {
        accountId: string
        provider: AccountProvider
        startDate: Date
        totalPayments: number
        amount: number
        walletAddress: string
        signedMessage: string
        signatureParams: SignatureParams
    }) => {
        await createSubscriptionMutation({
            variables: {
                createSubscriptionInput: {
                    accountId,
                    provider,
                    startDate,
                    walletAddress,
                    totalPayments,
                    amount,
                    network: Network.Polygon,
                    paymentToken: USDC_POLYGON.address.toLowerCase(),
                    tokenSymbol: 'USDC',
                    type: SubscriptionType.Autopay,
                    frequency: SubscriptionFrequency.Monthly,
                    signedMessage,
                },
                signatureParams,
            },
            refetchQueries: ['BillsData'],
            awaitRefetchQueries: true,
        })
    }

    return { createSubscription, loading }
}
